import { render, staticRenderFns } from "./ScannerPage.vue?vue&type=template&id=9c88c850"
import script from "./ScannerPage.vue?vue&type=script&lang=js"
export * from "./ScannerPage.vue?vue&type=script&lang=js"
import style0 from "./ScannerPage.vue?vue&type=style&index=0&id=9c88c850&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports